import React from 'react';
import { useTranslation } from 'react-i18next';
import { Page, theme, Typo, PageHeaderLogo, PageSection } from '../../ui';
import PageContainerVCenter from '../../ui/Page/PageContainerVCenter';
import { CONTENT_MINI } from '../../utils/media';

const CoursioDown = () => {
  const { t } = useTranslation();

  return (
    <Page backgroundColor={theme.colors.PRIMARY} fullheight={true}>
      <PageHeaderLogo />
      <PageContainerVCenter>
        <PageSection size={CONTENT_MINI}>
          <Typo.ContentSmallHeader $themeColor={theme.colors.PRIMARY}>{t('genericPages.downPage.genericMessage')}</Typo.ContentSmallHeader>
        </PageSection>
      </PageContainerVCenter>
    </Page>
  );
};

export default CoursioDown;
